module.exports = __webpack_public_path__ + "img/anchor.20d58974.png";